<div class="jumbotron text-center" style="height: 100vh;">
  <div class="d-table w-100 h-50">
    <pre class="d-table-cell align-middle h-100 w-100" style="font-size: 8vw;">¯\_(ツ)_/¯</pre>
  </div>
  <p class="lead">Oops... not found, try <a href="/">home</a>.</p>
</div>
